<p class="container-fluid">You are logged out. Click login in header to access CXB!</p>
